import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { TABLE_BORDER_COLOR } from 'HubStyleTokens/theme';
import GridItem from '../GridItem';
import { mediaQueries } from '../../utils/mediaQueries';
const sharedColumnStyles = css(["border-color:", ";border-style:solid;"], TABLE_BORDER_COLOR);
const LeftColumn = styled(GridItem).withConfig({
  displayName: "LeftColumnComp__LeftColumn",
  componentId: "f783sa-0"
})(["", " &&{padding:16px 32px 0 0;}", "{&&{padding:16px 0 0 0;max-width:100%;}}border-width:0 0 0 0;max-width:50%;"], sharedColumnStyles, mediaQueries.belowLaptop);

const LeftColumnComp = ({
  children,
  columnSpan
}) => {
  return /*#__PURE__*/_jsx(LeftColumn, {
    columns: columnSpan,
    className: "left-column",
    children: children
  });
};

export default LeftColumnComp;